import React, { useEffect, useRef } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

// styles
import './About.scss';



const About = () => {
	gsap.registerPlugin(ScrollTrigger);
	// store references for title and text
	const titleRef = useRef();
	const textRef = useRef();

	// wait until DOM has been rendered
	useEffect(() => {
		gsap.fromTo(
			titleRef.current,
			{ autoAlpha: 0.00, x: 2000 },
			{
				autoAlpha: 1,
				x: 0,
				duration: 1,
				ease: 'easeIn',
				scrollTrigger: {
					trigger: titleRef.current,
					start: 'top center-=90',
				},
			}
		);
		gsap.fromTo(
			textRef.current,
			{ autoAlpha: 0.00, x: -2000 },
			{
				autoAlpha: 1,
				x: 0,
				duration: 1,
				ease: 'easeIn',
				scrollTrigger: {
					trigger: textRef.current,
					start: 'top center-=90',
				},
			}
		);
	}, []);

	return (
		<div id="sobre">
			<Container fluid>
				<Row>
					<Col className="align-self-center text-danger bg-danger pb-14">
						<h1
							className="fw-bold text-center"
							id="info-title"
							ref={titleRef}>
							Hello, I am Francisco 👋
						</h1>
						<h2 className="mx-auto" id="info-text" ref={textRef}>
							Currently, I am doing my Master's degree in{' '}
							<b>Cyber Security</b> and{' '}
							<b>Artificial Inteligence</b> in{' '}
							<a
								href="https://tecnico.ulisboa.pt/pt/"
								target="_blank"
								rel="noreferrer">
								Instituto Superior Técnico, Lisbon University
							</a>
							. After finishing my Bachelor degree and internship,
							I decided to keep studying in these areas, because
							they were the ones that I like the most and was
							curious about. <br/>
						</h2>
					</Col>
				</Row>
			</Container>
		</div>
	);
};

export default About;
